// Budget-app formatting helpers — see BRIEF §3.
//
// The generic NZ-money `fmt` (em-dash for missing values) lives in @cca/ui —
// import it from there. This file keeps only the helpers specific to this app.
//
// CCAANZ display rules:
//   • No `$` sign
//   • Negatives in accountancy parens: (1,234)
//   • en-NZ thousands separator
//   • Tabular numerals (the `.num` CSS class — see globals.css)

// fmtMoney never returns the em-dash (always renders a number, even if zero).
// Used in summary strips and totals where blank cells would look broken.
export const fmtMoney = (n: number): string => {
  const r = Math.round(n);
  const abs = Math.abs(r).toLocaleString('en-NZ');
  return r < 0 ? `(${abs})` : abs;
};

// Year-label helpers derived from the editable base year (BRIEF §5.2).
export const yearLabel = (baseYear: number, offset: 0 | 1 | 2 | 3): string =>
  `FY${baseYear + offset}`;
